import React from "react";
import { Link } from "react-router-dom";
// import mission from "../../image/Garudayaan/fture.jpg";
// import graphs from "../../image/Garudayaan/past.jpg";
import mission from "../../image/Garudayaan/Future2.jpg";
import graphs from "../../image/Garudayaan/Past2.jpg";

const graphData = [
  {
    id: 1,
    title: "Accomplishment Timeline",
    desc: "Journey through our timeline of triumphs and milestones, showcasing our evolution and impact.",
    link: "/accomplishment-timeline",
    image: graphs,
  },
  {
    id: 2,
    title: "Accomplishment Saga Ahead",
    desc: "Explore our future journey of anticipated achievements and milestones.",
    link: "/future-graph",
    image: mission,
  },
];

const Graph = () => {
  return (
    <div className="bg-gradient-to-b from-white to-gray py-5">
      <div className="max-w-7xl h-full  mx-auto px-4   md:px-4">
        {/* Heading */}
        <div className="text-center mb-5 md:mb-5">
          <h2 className="text-2xl md:text-4xl font-bold text-[#9F2725]">
            OUR GROWTH JOURNEY
          </h2>
          <p className="text-gray-600 text-sm md:text-base mt-2">
            A visual story of our past achievements and future aspirations.
          </p>
        </div>

        {/* Desktop Grid / Mobile Slider */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 overflow-x-auto md:overflow-hidden snap-x snap-mandatory md:snap-none">
          {graphData.map((item) => (
            <div
              key={item.id}
              className="relative group flex-shrink-0 w-[90%] sm:w-[85%] md:w-auto snap-center"
            >
              {/* Image */}
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-[360px] md:h-[450px] object-contain bg-white rounded-2xl shadow-lg group-hover:scale-105 transition-transform duration-700"
              />

              {/* Floating Card Box */}
              <div
                className="absolute bottom-2 right-2 
                bg-black/30 backdrop-blur-sm text-white 
                p-2 md:p-4 rounded-md shadow-md 
                max-w-[65%] md:max-w-[40%] 
                transition-transform duration-500 group-hover:translate-y-[-6px]"
              >
                <h3 className="text-[11px] md:text-base font-semibold text-[#FFD700] mb-1 leading-tight">
                  {item.title}
                </h3>

                <p className="text-[9px] md:text-xs text-gray-200 leading-snug mb-2 line-clamp-2">
                  {item.desc}
                </p>

                <Link
                  to={item.link}
                  className="inline-block px-2 py-1 md:px-3 md:py-1.5 
               bg-[#9F2725] text-white 
               text-[9px] md:text-xs 
               rounded shadow hover:bg-[#7a1f1d] transition"
                >
                  Know More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Graph;
